import React, { Component } from "react";
import PropTypes from "prop-types";
import { graphql } from "react-apollo";
import { queryGetLabels } from "Apollo";
import Picker from "module-common/Picker";

export default graphql(queryGetLabels)(
  class PickerMultiLabel extends Component {
    static propTypes = {
      selectedLabels: PropTypes.array,
      onSelected: PropTypes.func
    };

    static defaultProps = {
      selectedLabels: []
    };

    render() {
      const { caseLabels, customerLabels, streamLabels } = this.props.data;
      const selectedLabels = this.props.selectedLabels;
      const allLabels = [];
      if (caseLabels) {
        for (const label of caseLabels) {
          allLabels.push({
            label: label.displayName,
            value: label
          });
        }
      }
      if (customerLabels) {
        for (const label of customerLabels) {
          allLabels.push({
            label: label.displayName,
            value: label
          });
        }
      }
      if (streamLabels) {
        for (const label of streamLabels) {
          allLabels.push({
            label: label.displayName,
            value: label
          });
        }
      }
      allLabels.forEach(label => {
        if (selectedLabels.some(row => label.value.id === row.value.id)) {
          label.selected = true;
        }
      });
      return (
        <Picker {...this.props} options={allLabels}>
          {this.props.children}
        </Picker>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/module-common/PickerMultiLabelWithQuery.js